import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=39d987f6&"
import script from "./Information.vue?vue&type=script&lang=ts&"
export * from "./Information.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports